import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
let getRandomValues;
const rnds8 = new Uint8Array(16);
export default function rng() {
  if (!getRandomValues) {
    if (typeof crypto === 'undefined' || !crypto.getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}